var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Alert from "@iscr/views/NUI/Alert";
import React from "react";
import { useProfile } from "../Hooks";
import { Link } from "react-router";
import { handleHealthCreditAlertSeen } from "../helpers/health_credit_helper";
export const UserHasCreditsAlert = (show_override = true) => {
    const [show, setShow] = React.useState(show_override);
    const [profile] = useProfile();
    const handleTermsPopUp = (e) => {
        e.preventDefault();
        app.trigger(app.events.SHOW_POPUP, {
            pt: "cx_txt",
            txt: "Health Credits Terms and Conditions",
            pn: "healthcredit-terms-and-conditions",
        });
    };
    const healthCredits = (profile === null || profile === void 0 ? void 0 : profile.healthcredits) || { amount: 0, code: "" };
    return (_jsx(Alert, { visible: show, warning: false, header: undefined, error: undefined, success: true, info: undefined, afterHr: undefined, wait: undefined, ext: undefined, doc: undefined, content: undefined, list: undefined, className: undefined, children: _jsxs("div", { className: "text-center pr-5", children: ["A $", healthCredits === null || healthCredits === void 0 ? void 0 : healthCredits.amount, " Health Credit has been applied to your account which you can use during checkout.", " ", _jsx(Link, { to: "#", onClick: handleTermsPopUp, children: "Conditions apply" })] }), onDismiss: () => __awaiter(void 0, void 0, void 0, function* () {
            yield handleHealthCreditAlertSeen(profile, healthCredits.code);
            setShow(false);
        }), basic: undefined, bg: undefined, hideIcon: true, rounded: false }));
};
